import { CurrencyPipe, PercentPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dynamicNumber',
  standalone: false
})
export class DynamicNumberPipe implements PipeTransform {
  constructor(
    private currencyPipe: CurrencyPipe,
    private percentPipe: PercentPipe,
    private decimalPipe: DecimalPipe
  ) {}

  transform(value: any, format: string, digitsInfo?: string): string {
    value = this.toNum(value);

    switch (format) {
      case 'currency':
        return this.currencyPipe.transform(value, 'EUR');

      case 'perc':
        return this.percentPipe.transform(
          value > 1 ? value / 100 : value,
          digitsInfo || '1.2-2'
        );

      case 'month':
        return this.decimalPipe.transform(value, digitsInfo || '1.0-0');

      default:
        return this.decimalPipe.transform(value, digitsInfo || '1.0-0');
    }
  }

  private toNum(value: any): number {
    if (typeof value === 'number') {
      return value;
    } else if (!isNaN(value)) {
      return Number(value);
    } else {
      return null;
    }
  }
}
